import apiClient from '@/services/axios'

export async function post(bookingIds) {
  const config = {responseType: 'blob'};
  const response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings/create-reservations-pdf',
    { bookingIds: bookingIds}, config);

  if (response) {
    return response.data;
  }

  throw new Error('Unable to post create-reservations-pdf');
}
